import { Component } from '@angular/core';
import GridViewUiComponent from '@iupics-components/standard/grid/grid-view-ui/grid-view-ui.component';
import { CellEditorComp, CellEditorParams } from '@iupics/apiz-grid';

@Component({
  selector: 'iu-button-editor',
  template: `
    <button type="button" (click)="onClick($event)" class="p-button p-button-secondary">{{ label }}</button>
  `,
  standalone: true,
})
export default class ButtonEditorComponent implements CellEditorComp {
  params: CellEditorParams;
  label: string;
  templates: any;
  activeGridView: GridViewUiComponent;

  gridInit(params: CellEditorParams) {
    this.params = params;
    this.label = this.params.label || this.params.colDef.headerName || this.params.colDef.field;
    this.templates = this.params.templates;
    this.activeGridView = this.params.activeGridView;
  }

  refresh(params: CellEditorParams): boolean {
    return true;
  }

  getValue() {
    return undefined;
  }

  onClick($event: MouseEvent) {
    if (!this.params.row.isSelected()) {
      this.params.row.setSelected(true); // select row
    }

    if (this.params.onSelect instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.row.getRowData(),
        columnName: this.params.colDef.field,
        // ...something
      };
      this.params.onSelect({ ...this.params, ...params });
    }
  }
}
